import React from "react"
import clsx from "clsx"
import DateHelper from "../../DateHelper/DateHelper";

class SurveyFormPresenterAnswers extends React.Component {
  
  constructor(props) {
    super(props)
  }

  render() {

    var tabClasses = clsx({
      'active': this.props.active_tab == 'survey_form_answers',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id='survey_form_answers'> 
        <div className="OrderFormBuilder" ref="form">
          <div className='panel panel-default' style={{paddingLeft:'0px', paddingRight:'0px', marginTop:'0px'}}>
            <div className="container" style={{ background: '#EFEFEF', paddingTop: '10px', height: 'auto', boxShadow: "3px 3px 7px rgba(0, 0, 0, 0.2)", paddingBottom: "5px"}}>
              <div className="row center_1">
                <div className="text-center col-md-12">
                  <img className="logo_image" src={this.props.logo_image_url} style={{width: 200, height: 'auto'}}></img> 
                </div>
              </div>
              <div className="row center_1">
                <div className="text-center col-md-12">
                  <label className="label_style">{this.props.property_name}</label>
                </div>
              </div>
              <div className="row center_1">
                <div className="text-center col-md-12">
                  <label className="label_style">{this.props.property_address}</label>
                </div>
              </div>
            </div>
            <div className="panel-body container" style={{paddingTop:"25px", marginTop: '0px', paddingLeft:"20px"}}>
              {this.renderFormFields(this.props.form_fields)}
            </div>
          </div>
        </div> 
      </div>
    )
  }
  renderFormFields(form_fields) { 
    var formFields = form_fields.sort((a, b) => a.position - b.position).map((form_field) => {
      var form_field_answer = null
      var number_field_answer = null
      var date_field_answer = null
      if(this.props.answers) {
        var customerAnswers = this.props.answers
        customerAnswers.map((answer) => {
          if(answer.form_field_id == form_field.id){
            if(answer.number_answer) {
              number_field_answer = answer.number_answer
            } else if(answer.date_answer) {
              date_field_answer = answer.date_answer
            } else if(answer.upload_file_name != null) {
              form_field_answer = answer      
            } else {
              form_field_answer = answer.answer
            }
          }
        })
      }

      if(form_field.field_type == "text_field_single_line") {
        return (
          <div className="form-field-row" key={form_field.id}>
            <div className="col-sm-6" style={{paddingBottom: "10px", paddingLeft: "0px"}}>
              <div className="form-group">
                <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <p>{form_field_answer ? form_field_answer : ""}</p>
              </div>
            </div>
          </div> 
        )
      }

      if(form_field.field_type == "select_box") {
        return (
          <div className="form-field-row" key={form_field.id}>
            <div className="col-sm-6" style={{paddingBottom: "10px", paddingLeft: "0px"}}>
                <div className="form-group ">
                  <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                  <p>{form_field_answer ? form_field_answer : ""}</p>
                </div>
            </div>
          </div>
        )
      }

      if(form_field.field_type == "number_input") {
        return (
          <div className="form-field-row" key={form_field.id} >
            <div className="col-sm-6" style={{paddingBottom: "10px", paddingLeft: "0px"}}>
              <div className="form-group">
                <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <p>{number_field_answer ? number_field_answer : ""}</p>
              </div>
            </div>
          </div>
        )
      }

      if(form_field.field_type == "date_form_field") {
        form_field_answer && typeof form_field_answer == 'string' ? form_field_answer = DateHelper.parseDateFromBackend(form_field_answer) : null;
        return (
          <div className="form-field-row" key={form_field.id}>
            <div className="col-sm-6" style={{paddingBottom: "10px", paddingLeft: "0px"}}>
              <div className="form-group">
                <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <p>{date_field_answer ? date_field_answer : ""}</p>
              </div>
            </div>  
          </div>
        )
      }

      if(form_field.field_type == "text_area_multi_line") {
        return (
          <div className="form-field-row" key={form_field.id}>
            <div className="col-sm-6" style={{paddingBottom: "10px", paddingLeft: "0px"}}>
              <div className="form-group">
                <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <p>{form_field_answer ? form_field_answer : ""}</p>
              </div>
            </div>      
          </div>
        )
      }

      if(form_field.field_type == "phone_number") {
        return (
          <div className="form-field-row" key={form_field.id}>
            <div className="col-sm-6" style={{paddingBottom: "10px", paddingLeft: "0px"}}>
              <div className="form-group">
                <label>{I18n.t('mobile_number')}*</label>
                <p>{form_field_answer ? form_field_answer : ""}</p>
              </div>
            </div>
          </div>
        )
      }

      if(form_field.field_type == "numbered_scale") {
        return (
          <div className="form-field-row" key={form_field.id}>
            <div className="col-sm-6" style={{paddingBottom: "10px", paddingLeft: "0px"}}>
              <div className="form-group">
                <label style={{paddingBottom: "10px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                {this.renderRatingRangeForm(form_field, form_field_answer ? form_field_answer : "")}  
              </div>
            </div>
          </div>
        )
      }

      if(form_field.field_type == "emoji_rating") {
        return (
          <div className="form-field-row" key={form_field.id}>
            <div className="col-sm-6" style={{paddingBottom: "10px", paddingLeft: "0px"}}>
              <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              {this.renderEmojiRatingForm(form_field, form_field_answer ? form_field_answer : "")}
              <br></br>
            </div>      
          </div>
        )
      }
    });

    return (
      <div>
        <div className="form-field-row">
          <div className="col-sm-6 form-group" style={{paddingLeft: "0px", paddingRight: "0px", marginBottom:"10px"}}>
            <div>
              <h4>{this.props.title}</h4>
            </div>
          </div>
        </div>
        <div className="form-field-row" style={{paddingBottom: "10px"}}>
          <div className="col-sm-6 form-group" style={{paddingLeft: "0px", paddingRight: "0px"}}>
            <div>
              <p><i>{this.props.description}</i></p>
            </div>
          </div>
        </div>
        <div className="form-group">
          {formFields}  
        </div>
      </div>
      
    );
  }
  renderEmojiRatingForm(form_field, form_field_answer) {
    var rating_range = 5
    var rating_range_arr = []

    for(let index = 0; index < rating_range; index++) {
      rating_range_arr.push(index + 1)  
    }

    var rating_range_lines = rating_range_arr.map((rating) => {
      if(rating_range == 5) {
        if(rating == 1) {
          var list_emoji = <i className="far fa-frown-open fa-2x"></i>
        }
        else if(rating == 2) {
          var list_emoji = <i className="far fa-frown fa-2x"></i>        
        } else if (rating == 3) {
          var list_emoji = <i className="far fa-meh fa-2x"></i>
        } else if (rating == 4) {
          var list_emoji = <i className="far fa-smile fa-2x"></i>   
        } else {
          var list_emoji = <i className="far fa-grin fa-2x"></i>
        }    
      }     
      return (
        <li className={rating == form_field_answer ? `selected-emoji-scale-li` : `emoji-scale-li`} key={rating}>{list_emoji}</li>
      )
    })
    
    return (
      <ul className="emoji-scale-ul">
        {rating_range_lines}
      </ul>
    )
  }

  renderRatingRangeForm(form_field, form_field_answer) {
    if(form_field && form_field.rating_range.rating_range.length > 0) {
      var rating_range = parseInt(form_field.rating_range.rating_range, 10)
      var rating_range_arr = []

      for(let index = 0; index < rating_range; index++) {
        rating_range_arr.push(index + 1)  
      }

      var rating_range_lines = rating_range_arr.map((rating) => {
        if(rating_range == 10) {
          if(rating <= 3){
            var color = "#aa381d"
          } else if (rating > 3 && rating <= 6) {
            var color = "#d18140"
          } else if (rating > 3 && rating <= 6) {
            var color = "#bba350"
          } else {
            var color = "#61a544"
          }
        }

        if(rating_range == 5) {
          if(rating < 3){
            var color = "#aa381d"
          } else if (rating  == 3) {
            var color = "#bba350"
          } else if (rating > 3 && rating <= 6) {
            var color = "#61a544"
          } else {
            var color = "#61a544"
          }
        }    
        return (
          <li className={rating == form_field_answer ? "selected-rating-scale-li" : "rating-scale-li"}  key={rating} style={{borderColor: color, color:color}}>{rating}</li>
        )
      })
    }
    return (
      <ul className="rating-scale-ul">
        {rating_range_lines}
      </ul>    
    )
  }
}

export default SurveyFormPresenterAnswers